import { useDispatch } from 'react-redux';
import { useChatSlice } from '../slice';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/constants';

export default function useNewChatHandler() {
  const dispatch = useDispatch();
  const { actions } = useChatSlice();
  const navigate = useNavigate();
  const handleNewChat = () => {
    dispatch(actions.onNewChat());
    navigate(ROUTE_PATHS.PORTAL);
  };
  return { handleNewChat };
}
